import Vue from 'vue'
import 'es6-promise/auto'
import App from './App.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#products_form')
